// Mock Badge Component
// Displays a badge indicating that example/mock data is being shown

import React from 'react';
import { Info } from 'lucide-react';

interface MockBadgeProps {
  className?: string;
  variant?: 'small' | 'medium' | 'large';
  showIcon?: boolean;
  children?: React.ReactNode;
}

export const MockBadge: React.FC<MockBadgeProps> = ({ 
  className = '', 
  variant = 'medium',
  showIcon = true,
  children = 'Example Data'
}) => {
  const baseClasses = 'inline-flex items-center px-2 py-1 rounded-full text-xs font-medium border';
  
  const variantClasses = {
    small: 'px-1.5 py-0.5 text-xs',
    medium: 'px-2 py-1 text-xs',
    large: 'px-3 py-1.5 text-sm'
  };
  
  const colorClasses = 'bg-yellow-50 text-yellow-700 border-yellow-200 dark:bg-yellow-900/20 dark:text-yellow-400 dark:border-yellow-800';
  
  const classes = `${baseClasses} ${variantClasses[variant]} ${colorClasses} ${className}`;

  return (
    <span className={classes}>
      {showIcon && (
        <Info className="w-3 h-3 mr-1 flex-shrink-0" />
      )}
      {children}
    </span>
  );
};

export default MockBadge; 